// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"72c46b97e0dbbec85166","339":"0865d85c7c067dcfcad7"}[chunkId] + ".js";
};